/**
 * farliMapPref — tiny localStorage helper for the "show Farli on the
 * live map" preference. Drives FarliFloatingButton's visibility on
 * /kort and is toggled from MapMenu (the "Mere" sheet).
 *
 * Default: OFF. The map is the hero — the mascot only appears when
 * the rider explicitly opts in from Mere → Farli.
 */
import { useEffect, useState } from 'react';

const KEY = 'baremc.farliOnMap';
const EVT = 'baremc:farli-map-changed';

export function getFarliOnMap() {
  try { return localStorage.getItem(KEY) === '1'; } catch { return false; }
}

export function setFarliOnMap(on) {
  try {
    if (on) localStorage.setItem(KEY, '1');
    else localStorage.removeItem(KEY);
    window.dispatchEvent(new CustomEvent(EVT, { detail: !!on }));
  } catch { /* ignore */ }
}

export function useFarliOnMap() {
  const [on, setOn] = useState(getFarliOnMap());
  useEffect(() => {
    const handler = (e) => setOn(!!(e?.detail));
    const storage = () => setOn(getFarliOnMap());
    window.addEventListener(EVT, handler);
    window.addEventListener('storage', storage);
    return () => {
      window.removeEventListener(EVT, handler);
      window.removeEventListener('storage', storage);
    };
  }, []);
  return [on, setFarliOnMap];
}
